import { Radio } from "@mimber/ui-web"
import { FormItem } from "react-hook-form-antd"
import { useFormContext } from "react-hook-form"
import type { FieldValues, FieldPath } from "react-hook-form"
import type { RadioGroupFieldProps } from "./RadioGroupField.types"

export function RadioGroupField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  disabled,
  children,
}: RadioGroupFieldProps<TFieldValues, TName>) {
  const { control: contextControl } = useFormContext<TFieldValues>()
  const formControl = control || contextControl

  return (
    <FormItem
      control={formControl}
      name={name}
      label={label}
      required={required}
      help={help}
    >
      <Radio.Group disabled={disabled}>{children}</Radio.Group>
    </FormItem>
  )
}
